import { createContext, useState } from "react";

const productStatsFilterContext = createContext({
    filterDate: { value: [], isActive: 0 },
    filterBread: { value: [], isActive: 0 },
    setFilterDate: () => { },
    setFilterBread: () => { },
});

export function ProductStatsFilterProvider(props) {
    const [filterDate, setFilterDate] = useState({ value: [new Date()], isActive: 0 });
    const [filterBread, setFilterBread] = useState({
        value: [],
        isActive: 0,
    });

    const context = {
        filterDate,
        setFilterDate,
        filterBread,
        setFilterBread,
    };

    return (
        <productStatsFilterContext.Provider value={context}>
            {props.children}
        </productStatsFilterContext.Provider>
    );
}

export default productStatsFilterContext;
